import tns from "tiny-slider";

const CLASS_HIDDEN = "floating-news--hidden";

const widgets = document.querySelectorAll(".js-floating-news");
[...widgets].forEach(widget => {
	const container = widget.querySelector(".js-container");
	const controlsContainer = widget.querySelector(".js-controls");
	tns({
		container,
		controlsContainer,
		nav: false
	});

	const close = widget.querySelector(".js-close");
	close.addEventListener(
		"click",
		() => {
			widget.classList.add(CLASS_HIDDEN);

			const date = new Date();
			const hours = 24;
			date.setTime(date.getTime() + hours * 60 * 60 * 1000);
			const expires = "; expires=" + date.toGMTString();
			document.cookie = "hidestickynews=true" + expires + "; path=/";
		},
		false
	);

	widget.style.opacity = 1;
});
